module.exports = __webpack_public_path__ + "media/images/common/back_btn_l-2286d9188378d4a52e074d895d762724.png";